export const FooterConfig = `Copyright © 2022. All rights reserved. Powered by ASEPSIS`